//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    visible() {
      return ['/', '/header', '/search', '/infinite-calendar'].indexOf(this.$route.path) < 0;
    },
    routeName() {
      return this.$route.name;
    }
  },
  mounted() {
    if (window.location.hash.indexOf('smile-select') > -1) {
      history.back();
    }
  }
};



// WEBPACK FOOTER //
// ./example/app.vue